import React from 'react'
import {
    extend,
    useThree,
  } from '@react-three/fiber'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
extend({ OrbitControls });
const Orbit = () => {
  const { camera, gl } = useThree();
  return <orbitControls attach='orbitControls' args={[camera, gl.domElement]}></orbitControls>
}
export default Orbit;